import { $Q, $Qll } from "../utils/query-selector";

/**
 * in this module the zoom functionality is created by means of a magnifying
glass, while hovering over the image in question.
The location of the pointer and the x and y execs are handled a lot.
in summary it detects in which part of the image I am to show the
cloned image with a zoom, in the indicated space by means of css.
 * @param {ElementHTML} img - image element by clone and create zoom hover
 * @param {Number} zoom - quantity zoom
 */
function magnify(img, zoom) {

  /* Create magnifier glass: */
  const glass = document.createElement("DIV");
  glass.setAttribute("class", "img-magnifier-glass");

  /* Insert magnifier glass: */
  img.parentElement.insertBefore(glass, img);

  /* Set background properties for the magnifier glass: */
  glass.style.backgroundImage = `url('${ img.src.split('&')[0] }')`;
  glass.style.backgroundRepeat = "no-repeat";
  glass.style.display = "none";
  const width = glass.offsetWidth / 2;
  const height = glass.offsetHeight / 2;

  function getCursorPos(e) {
    let x = 0, y = 0;
    const event = e || window.event;
    /* Get the x and y positions of the image: */
    const imagePosition = img.getBoundingClientRect();
    /* Calculate the cursor's x and y coordinates, relative to the image: */
    x = event.pageX - imagePosition.left;
    y = event.pageY - imagePosition.top;
    /* Consider any page scrolling: */
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return {x: x, y: y};
  }

  /*and also for touch screens:*/
  function moveMagnifier(e) {
    let x, y;
    /* Prevent any other actions that may occur when moving over the image */
    e.preventDefault();
    /* Get the cursor's x and y positions: */
    const pos = getCursorPos(e);
    x = pos.x;
    y = pos.y;
    /* Prevent the magnifier glass from being positioned outside the image: */
    if (x > img.width - (width / zoom)) { x = img.width - (width / zoom); }
    if (x < width / zoom) { x = width / zoom; }
    if (y > img.height - (height / zoom)) { y = img.height - (height / zoom); }
    if (y < height / zoom) { y = height / zoom; }

    const offsetX = (width - (width / zoom)) / 2 + 100; // Calculate the offset in X 
    const offsetY = (height - (height / zoom)) / 2 + 100; // Calculate the offset in y

    /* Set the position of the magnifier glass: */
    glass.style.left = `${x - offsetX}px`; // Apply the offset in y
    glass.style.top = `${y - offsetY}px`; // Apply the offset in X
  
    /* Display what the magnifier glass "sees": */
    glass.style.backgroundPosition = `-${(x * zoom) - offsetX}px -${(y * zoom) - offsetY}px`; // Apply the offset in X and Y to the zoom
  }

  img.parentElement.addEventListener("mouseleave", () => {
    glass.style.display = "none";
  })

  img.parentElement.addEventListener("mouseenter", () => {
    glass.style.backgroundSize = `${img.width * zoom }px ${ img.height * zoom }px`;
    glass.style.display = "block";
  })

   /* Execute a function when someone moves
  the magnifier glass over the image: */
  glass.addEventListener("mousemove", moveMagnifier);
  img.addEventListener("mousemove", moveMagnifier);
}

export function hoverOnZoom() {
  const elements = $Qll(".myimage");
  elements.forEach((element) => {
    magnify(element, 2);
  });
}

export function enableMobileZoom(imageSelector) {
  const imageEl = $Q(imageSelector);
  console.log(imageEl)
  if (!imageEl) return;

  let currentScale = 1; // The current scale value of the image.
  let startDistance = 0; // he distance between two fingers at the start of the pinch gesture.
  let startScale = 1; // The value of currentScale at the start of the pinch gesture.
  let startX = 0; // The X coordinate of the first finger at the start of the pinch gesture.
  let startY = 0; // The Y coordinate of the first finger at the start of the pinch gesture.
  let touchCount = 0; // The number of fingers touching the image.

  /**
   * Function that runs when the image is double-clicked.
   * It calculates the zoom center at the point where the click was made,
   * applies the CSS matrix transformation to zoom in, and saves the value of currentScale at 3.
   * @param {*} event
   * @returns stop called
   */
  const handleClickStart = (event) => {
    event.preventDefault();
    event.stopPropagation();

    console.log(imageEl)

    // Revisa si la imagen ya tiene una matriz de transformación aplicada
    const hasTransformMatrix = window.getComputedStyle(imageEl).getPropertyValue("transform");
    const matrix = hasTransformMatrix.match(/^matrix\((.+)\)$/);

    if (matrix) {
      imageEl.style.transform = '';
      return;
    }

    const boundingRect = imageEl.getBoundingClientRect();
    const x = event.clientX - boundingRect.left;
    const y = event.clientY - boundingRect.top;
    const centerX = x / boundingRect.width;
    const centerY = y / boundingRect.height;

    const transform = `matrix(${3}, 0, 0, ${3}, ${putLimit(-centerX * (3 - 1), 500)}, ${putLimit(-centerY * (3 - 1), 600)})`;

    currentScale = 3

    imageEl.style.transform = transform;
  }

  /**
   * Function that runs when the image is touched with one or two fingers.}
   * If touched with one finger,it saves the starting touch coordinates and applies a transition to the image.
   * If touched with two fingers, it saves the distance between them and the current value of currentScale.
   * @param {*} event
   * @returns
   */
  const handleTouchStart = (event) => {
    if (!event || !event.touches) return;
    touchCount = event.touches.length;

    if (touchCount === 1) {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      imageEl.style.transition = "transform 0.1s ease-out";
    } else if (touchCount === 2) {
      const touch1 = event.touches[0];
      const touch2 = event.touches[1];
      const distance = getDistance(touch1, touch2);

      startDistance = distance;
      startScale = currentScale;
      imageEl.style.transition = "";
    }
  };

  /**
   * The putLimit function limits a given value to a specified limit.
   * If the value is negative, it limits it to the negative limit.
   * If the value is positive, it limits it to the positive limit.
   * @param {num} axis
   * @param {num} limit
   * @returns {num} - axis
   */
  const putLimit = (axis, limit) => {
    if (axis < 0) {
      return axis < -limit ? -limit : axis
    } else {
      return axis > limit ? limit : axis
    }
  }

  /**
   * Function that runs when one or two fingers are moved over the image.
   * If one finger is moved, it calculates the position difference from the starting touch,
   * calculates the new coordinates of the image, and updates the image transformation.
   * If two fingers are moved, it calculates the distance between them and the new value of currentScale,
   * and updates the image transformation.
   * @param {*} event
   * @returns
   */
  const handleTouchMove = (event) => {
    event.preventDefault();
    if (!event || !event.touches) return;

    if (touchCount === 1) {
      // Si se mueve un dedo, calcula el desplazamiento y actualiza la posición de la imagen
      const currentX = event.touches[0].clientX;
      const currentY = event.touches[0].clientY;

      const deltaX = currentX - startX;
      const deltaY = currentY - startY;

      const matrix = getTransformMatrix(imageEl);
      const x = matrix[4] + deltaX;
      const y = matrix[5] + deltaY;

      imageEl.style.transform = `matrix(${currentScale}, 0, 0, ${currentScale}, ${putLimit(x, 500)}, ${putLimit(y, 600)})`;
    } else if (touchCount === 2) {
      const touch1 = event.touches[0];
      const touch2 = event.touches[1];

      if (touch2) {
        const distance = getDistance(touch1, touch2);
        const scale = distance / startDistance * startScale;

        currentScale = Math.max(1, Math.min(scale, 3));
        updateTransform(imageEl, currentScale);
      }
    }
  };

  /**
   * Function that runs when one or two fingers are lifted off the image.
   * If currentScale is 1, it removes the image transformation and applies a transition.
   */
  const handleTouchEnd = () => {
    if (currentScale === 1) {
      imageEl.style.transform = "";
      imageEl.style.transition = "transform 0.2s ease-out";
    }
  };

  /**
   * Function that gets the CSS transformation matrix of an element and returns it as an array of 6 numbers.
   * @param {node} element
   * @returns
   */
  const getTransformMatrix = (element) => {
    const transform = window.getComputedStyle(element).getPropertyValue("transform");
    const matrix = transform.match(/^matrix\((.+)\)$/);

    if (matrix) {
      return matrix[1].split(",").map(parseFloat);
    }

    return [1, 0, 0, 1, 0, 0];
  };

  /**
   * Function that updates the CSS transformation matrix of an element with the specified scale value.
   * @param {node} element
   * @param {num} scale
   */
  const updateTransform = (element, scale) => {
    const matrix = getTransformMatrix(element);
    matrix[0] = scale;
    matrix[3] = scale;
    matrix[4] = putLimit(matrix[4], 500);
    matrix[5] = putLimit(matrix[5], 600);
    element.style.transform = `matrix(${matrix.join(",")})`;
  };

  /**
   * Function that calculates the distance between two points.
   * @param {object} touch1
   * @param {object} touch2
   * @returns {num}
   */
  const getDistance = (touch1, touch2) => {
    const deltaX = touch2.clientX - touch1.clientX;
    const deltaY = touch2.clientY - touch1.clientY;

    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
  };

  imageEl.addEventListener("dblclick", handleClickStart);
  imageEl.addEventListener("touchstart", handleTouchStart, { passive: true });
  imageEl.addEventListener("touchmove", handleTouchMove, { passive: true });
  imageEl.addEventListener("touchend", handleTouchEnd, { passive: true });
}
